<template>
    <form class="module-time-tracker" ref="form">
        <template v-if="loading">
            <loading-indicator/>
        </template>
        <template v-else>
            <form-row label="Mitarbeiter" error-name="employee_id" required>
                <form-select v-model="employee" :options="employees"/>
            </form-row>
            <form-row label="Typ" error-name="type" required>
                <form-select v-model="type" :options="typeOptions" name="type"/>
            </form-row>
            <form-row label="Startwert" error-name="overtime_hours" required>
                <form-input v-model="account" type="text" name="overtime_hours" placeholder="Stunden oder S:MM oder SS:MM"/>
            </form-row>
        </template>
    </form>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator';
    import FormInput from '../../../components/form/FormInput.vue';
    import FormRow from '../../../components/form/FormRow.vue';
    import FormSelect from '../../../components/form/FormSelect.vue';
    import LoadingIndicator from '../../../components/LoadingIndicator.vue';
    import {formSubmit, getFormData, parseFormData} from '../../../library/form';
    import {popupDefaultCancelButton} from '../../../library/popup';
    import TopMessageHandler from '../../../library/topMessageHandler';
    import {errorHandler} from '../../../utils/portuna';

    @Component({
        name: 'EditOvertimeStartPopup',
        components: {
            FormInput,
            FormSelect,
            LoadingIndicator,
            FormRow},
    })
    export default class EditOvertimeStartPopup extends Vue
    {
        readonly $refs: {
            form: HTMLFormElement,
        };

        @Prop({
            type: Number,
            default: 0,
            required: false,
        }) id: number;

        employee: number = 0;

        type: Nullable<number> = null;

        account: string = '';

        employees: Record<number, string> = {};

        loading: boolean = true;

        @Watch('employee')
        watchEmployee()
        {
            this.fetch();
        }

        get typeOptions()
        {
            return [
                {
                    value: 0,
                    label: 'Überstunden',
                },
                {
                    value: 1,
                    label: 'Minusstunden',
                },
            ];
        }

        created()
        {
            this.employee = this.id;
            this.emitter.emit('setButtons', [
                popupDefaultCancelButton,
                {
                    type: 'success',
                    title: 'Speichern',
                    icon: 'save',
                    cmd: () => this.post(),
                },
            ] as PopupButton[]);
            this.fetch();
        }

        fetch()
        {
            this.loading = true;
            this.axios.get(`/employee/time-tracker/overtime/change-start/employee/${this.employee}`)
            .then(({data: {data: r}}) => {
                this.$store.dispatch('form/setFilter', r.filter);
                this.employees = r.employees;
                if(null !== r.overtime_minutes)
                {
                    this.type = r.overtime_minutes < 0 ? 1 : 0;
                }
                this.account = r.overtime_account;
                this.loading = false;
                this.emitter.emit('lazy-load-focus');
            })
            .catch((err) => {
                errorHandler(err);
                this.emitter.emit('close');
            })
        }

        post()
        {
            let formData = getFormData(this.$refs.form);
            formSubmit(`/employee/time-tracker/overtime/change-start/employee/${this.employee}`, parseFormData(formData))
            .then(() => {
                TopMessageHandler.success('Der Startwert wurde erfolgreich gespeichert.');
                this.emitter.emit('close');
            });
        }
    }
</script>